export default {
  //APP_ROOT_PATH:'/boardroom/',
  APP_ROOT_PATH: '/',
  API_URL_LOCAL: 'http://localhost:44326',
  API_URL_UAT: 'http://lamacapi.brl.local:8080',
  API_URL_CLIENT_UAT: 'https://lamacapi.boardroomlimited.com',
  API_URL_PROD: 'https://benconnectapi.boardroomlimited.com',
  NO_RECORD_TEXT: 'No records found',
  LOADING_EMPLOYEE_NAME: '[Loading...]',
  TIMESHEET_STATUS_BLANK: 'BLANK',
  TIMESHEET_STATUS_NEW: 'NEW',
  TIMESHEET_STATUS_DRAFT: 'DRAFT',
  TIMESHEET_STATUS_PENDING: 'PENDING',
  TIMESHEET_STATUS_REJECTED: 'REJECTED',
  TIMESHEET_STATUS_APPROVED: 'APPROVED',
  ENABLE_INSURANCE_MODULE: true,
  ENABLE_ATTENDANCE_MODULE: true,
  ENABLE_CAR_PARK_MODULE: true,
  ENABLE_CORPORATE_PASS_MODULE: true,
  ENABLE_DELEGATION_MODULE: true,
  DISABLE_COPORATE_PASS_FOR_EMPLOYEE: false,
  ALLOWED_CORPORATE_PASS_EMPLOYEE: ['LAMSGEE', 'LAMMYEE', 'LAMSGMGR', 'ACD1000', 'ACD1001'],
  ENABLE_LEAVE_ABSENCE_MODULE: true,
  ENABLE_EMAIL_LOG_MODULE: true,
  ENABLE_SYNC_LOG_MODULE: true,
  ENABLE_REMINDER_MODULE: true,
  ENABLE_WORK_CALENDAR_MODULE: true,
  ENABLE_MENU_MODULE: true,
  ENABLE_FWA_MODULE: true,
  ENABLE_LEAVE_UTILIZATION_REPORT_MODULE: true,
  CARPARKCLAIM_STATUS_BLANK: 'BLANK',
  CARPARKCLAIM_STATUS_NEW: 'NEW',
  CARPARKCLAIM_STATUS_DRAFT: 'DRAFT',
  CARPARKCLAIM_STATUS_PENDING: 'PENDING',
  CARPARKCLAIM_STATUS_REJECTED: 'REJECTED',
  CARPARKCLAIM_STATUS_APPROVED: 'APPROVED',
  DEFAULT_COMPANY: 'Lam Research Singapore Pte Ltd',
  UPLOAD_FILE_LIMIT_MB: 30,
  CORPORATE_PASS_TYPE_PHYSICAL_CARD: 'Physical Card',
  CORPORATE_PASS_TYPE_ETICKET: 'e-Ticket',
  REMINDER_CAR_PARK_CLAIM_APPROVAL: 'Car Park Claim Approval',
  REMINDER_TIMESHEET_APPROVAL: 'Timesheet Approval',
  REMINDER_FWA_APPROVAL: 'FWA Approval',
  REMINDER_FWA_CANCELLATION_APPROVAL: 'FWA Cancellation Approval'
}


// WEBPACK FOOTER //
// ./src/config.js